'use client';

import dynamic from 'next/dynamic';
import type { ArticleDetailProps } from '@/components/pages/article-detail/types';

const ArticleDetail = dynamic(() => import('@/components/pages/article-detail'));

const ArticleDetailClientWrapper = (props: ArticleDetailProps) => <ArticleDetail {...props} />;

export default ArticleDetailClientWrapper;
